import Head from 'next/head';
import { useRouter } from 'next/router';
import useTranslation from '../../hooks/useTranslation';

const HeadSeo: React.FC = () => {
  const { t } = useTranslation();
  const { asPath, locale } = useRouter();

  const seo = {
    title: t('defaultTitleSeo'),
    description: t('defaultDescriptionSeo'),
    image: t('defaultImageSeo'),
    keywords: t('defaultKeywordsSeo'),
    url: `https://instasorteio.com/sorteio-de-numeros${locale !== 'pt' ? `${asPath}${locale}` : '/'}`
  };

  return (
    <Head>
      <title>{seo.title}</title>
      <link rel='icon' href='/favicon.ico' />
      <meta name='description' content={seo.description} />
      <meta name='keywords' content={seo.keywords} />

      <meta itemProp='name' content={seo.title} />
      <meta itemProp='description' content={seo.description} />
      <meta itemProp='image' content={seo.image} />

      <meta property='og:url' content={seo.url} />
      <meta property='og:type' content='website' />
      <meta property='og:title' content={seo.title} />
      <meta property='og:description' content={seo.description} />
      <meta property='og:image' content={seo.image} />

      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />

      <link rel='canonical' href={seo.url} />

      <meta
        name='viewport'
        content='width=device-width, initial-scale=1, maximum-scale=5'
      />
    </Head>
  );
}

export default HeadSeo;